import React from 'react';
import { Card, Button } from 'react-bootstrap';
import useToken from 'hooks/useToken';
import { useToast } from 'context/providers/ToastProvider';

import TablaLicenciasPendientes from '../TablaLicenciasPendientes';
import TablaEmpresasYaProgramadas from '../TablaEmpresasYaProgramadas';
import TablaEmpresasYaBorradas from '../TablaEmpresasYaBorradas';
import TarjetasResumenKPI from '../TarjetasResumenKPI';
import HeaderFiltrosBorrado from '../HeaderFiltrosBorrado';

import ModalConfirmacionBorrado from './ModalConfirmacionBorrado';
import PaginacionFooter from './PaginacionFooter';
import useLicenciasBorradoData from './useLicenciasBorradoData';
import useAccionesBorrado from './useAccionesBorrado';
import {
    formatearFechaLarga,
    formatearFechaCorta,
    esTieneAmbas,
    copiarAlPortapapeles
} from './formatters';

const LicenciasVencidasDataBorrado = () => {
    const { token, idCatTipoUsuario } = useToken();
    const isAdmin = idCatTipoUsuario === 1 || idCatTipoUsuario === '1';
    const { showErrorToast, showSuccessToast } = useToast();

    // Hook de datos, filtrado y paginación
    const data = useLicenciasBorradoData({ token, showErrorToast });

    // Hook de acciones masivas y confirmación
    const acciones = useAccionesBorrado({
        token,
        isAdmin,
        data,
        showSuccessToast,
        showErrorToast
    });

    const {
        candidatasPaginadas,
        licenciasSeleccionadas,
        todasSeleccionadasPaginaActual,
        cargando,
        resumen,
        busqueda,
        setBusqueda,
        conteoTabs,
        mesesVencimiento,
        tipoLicencia,
        ordenDias,
        pagina,
        setPagina,
        tamanioPagina,
        setTamanioPagina,
        estatusBorrado,
        totalRegistros,
        totalPaginas,
        toggleSeleccion,
        toggleSeleccionarTodo,
        handleCambiarMeses,
        handleCambiarTipoLicencia,
        handleCambiarEstatusBorrado,
        toggleOrdenColumna
    } = data;

    const {
        modalConfirm,
        cerrarModalConfirmacion,
        handleEliminarSeleccionadas,
        handleQuitarBorrado,
        handleReintentarBorrado,
        handleDescartarNoBorradas,
        handleEjecutarBorradoInmediato,
        handleExportarExcel
    } = acciones;

    return (
        <>
            {/* Header de Filtros y Acciones */}
            <HeaderFiltrosBorrado
                estatusBorrado={estatusBorrado}
                handleCambiarEstatusBorrado={handleCambiarEstatusBorrado}
                conteoTabs={conteoTabs}
                busqueda={busqueda}
                handleCambiarBusqueda={(e) => { setBusqueda(e.target.value); setPagina(1); }}
                handleLimpiarBusqueda={() => { setBusqueda(''); setPagina(1); }}
                tipoLicencia={tipoLicencia}
                handleCambiarTipoLicencia={handleCambiarTipoLicencia}
                mesesVencimiento={mesesVencimiento}
                handleCambiarMeses={handleCambiarMeses}
                cargando={cargando}
            >
                {isAdmin && licenciasSeleccionadas.length > 0 && estatusBorrado === 0 && (
                    <Button
                        variant="primary"
                        size="sm"
                        className="d-flex align-items-center justify-content-center gap-2 px-3 py-2 fw-semi-bold text-white shadow-none flex-grow-1 flex-xl-grow-0"
                        style={{ borderRadius: '8px', height: '38px' }}
                        onClick={handleEliminarSeleccionadas}
                        disabled={cargando}
                    >
                        <i className="far fa-clock"></i>
                        <span>Programar Borrado ({licenciasSeleccionadas.length})</span>
                    </Button>
                )}
                {isAdmin && licenciasSeleccionadas.length > 0 && estatusBorrado === 1 && (
                    <Button
                        variant="warning"
                        size="sm"
                        className="d-flex align-items-center justify-content-center gap-2 px-3 py-2 fw-semi-bold text-white shadow-none flex-grow-1 flex-xl-grow-0"
                        style={{ borderRadius: '8px', height: '38px' }}
                        onClick={handleQuitarBorrado}
                        disabled={cargando}
                    >
                        <i className="fas fa-undo"></i>
                        <span>Quitar del Borrado ({licenciasSeleccionadas.length})</span>
                    </Button>
                )}
                {isAdmin && licenciasSeleccionadas.length > 0 && estatusBorrado === 2 && (
                    <>
                        <Button
                            variant="primary"
                            size="sm"
                            className="d-flex align-items-center justify-content-center gap-2 px-3 py-2 fw-semi-bold text-white shadow-none flex-grow-1 flex-xl-grow-0"
                            style={{ borderRadius: '8px', height: '38px' }}
                            onClick={() => handleReintentarBorrado()}
                            disabled={cargando}
                        >
                            <i className="fas fa-redo"></i>
                            <span>Reintentar ({licenciasSeleccionadas.length})</span>
                        </Button>
                        <Button
                            variant="outline-danger"
                            size="sm"
                            className="d-flex align-items-center justify-content-center gap-2 px-3 py-2 fw-semi-bold shadow-none flex-grow-1 flex-xl-grow-0"
                            style={{ borderRadius: '8px', height: '38px' }}
                            onClick={() => handleDescartarNoBorradas()}
                            disabled={cargando}
                        >
                            <i className="fas fa-trash-alt"></i>
                            <span>Descartar ({licenciasSeleccionadas.length})</span>
                        </Button>
                    </>
                )}
                <Button
                    variant="outline-success"
                    size="sm"
                    className="d-flex align-items-center justify-content-center gap-2 px-3 py-2 fw-semi-bold text-nowrap shadow-none flex-grow-1 flex-xl-grow-0"
                    style={{ borderRadius: '8px', height: '38px' }}
                    onClick={handleExportarExcel}
                    disabled={cargando}
                    title="Exportar a Excel"
                >
                    <i className="far fa-file-excel fs-0"></i>
                    <span>Exportar a Excel</span>
                </Button>
                {isAdmin && (
                    <Button
                        variant="danger"
                        size="sm"
                        className="d-flex align-items-center justify-content-center gap-2 px-3 py-2 fw-semi-bold text-white text-nowrap shadow-none flex-grow-1 flex-xl-grow-0"
                        style={{ backgroundColor: '#e63757', borderColor: '#e63757', borderRadius: '8px', height: '38px' }}
                        onClick={handleEjecutarBorradoInmediato}
                        disabled={cargando || ((conteoTabs?.[1] || resumen?.iTotalProgramadas || 0) === 0)}
                        title={((conteoTabs?.[1] || resumen?.iTotalProgramadas || 0) === 0) ? "No hay empresas programadas para borrado" : "Ejecutar el servicio de borrado inmediatamente"}
                    >
                        <i className="far fa-trash-alt fs-0"></i>
                        <span>Ejecutar Borrado Inmediato</span>
                    </Button>
                )}
            </HeaderFiltrosBorrado>

            {/* Tarjetas de Resumen KPI */}
            <TarjetasResumenKPI resumen={resumen} estatusBorrado={estatusBorrado} />

            {/* Tabla Principal */}
            <Card>
                <Card.Body className="p-0">
                    {estatusBorrado === 2 || estatusBorrado === 3 ? (
                        <TablaEmpresasYaBorradas
                            candidatasPaginadas={candidatasPaginadas}
                            licenciasSeleccionadas={licenciasSeleccionadas}
                            todasSeleccionadasPaginaActual={todasSeleccionadasPaginaActual}
                            toggleSeleccionarTodo={toggleSeleccionarTodo}
                            toggleSeleccion={toggleSeleccion}
                            cargando={cargando}
                            formatearFechaLarga={formatearFechaLarga}
                            formatearFechaCorta={formatearFechaCorta}
                            copiarAlPortapapeles={(t) => copiarAlPortapapeles(t, showSuccessToast, showErrorToast)}
                            estatusBorrado={estatusBorrado}
                            isAdmin={isAdmin}
                            handleReintentarBorrado={handleReintentarBorrado}
                            handleDescartarNoBorradas={handleDescartarNoBorradas}
                        />
                    ) : estatusBorrado === 1 ? (
                        <TablaEmpresasYaProgramadas
                            candidatasPaginadas={candidatasPaginadas}
                            licenciasSeleccionadas={licenciasSeleccionadas}
                            todasSeleccionadasPaginaActual={todasSeleccionadasPaginaActual}
                            toggleSeleccionarTodo={toggleSeleccionarTodo}
                            toggleSeleccion={toggleSeleccion}
                            cargando={cargando}
                            formatearFechaLarga={formatearFechaLarga}
                            formatearFechaCorta={formatearFechaCorta}
                            copiarAlPortapapeles={(t) => copiarAlPortapapeles(t, showSuccessToast, showErrorToast)}
                            toggleOrdenColumna={toggleOrdenColumna}
                            ordenDias={ordenDias}
                            isAdmin={isAdmin}
                        />
                    ) : (
                        <TablaLicenciasPendientes
                            candidatasPaginadas={candidatasPaginadas}
                            licenciasSeleccionadas={licenciasSeleccionadas}
                            todasSeleccionadasPaginaActual={todasSeleccionadasPaginaActual}
                            toggleSeleccionarTodo={toggleSeleccionarTodo}
                            toggleSeleccion={toggleSeleccion}
                            cargando={cargando}
                            toggleOrdenColumna={toggleOrdenColumna}
                            ordenDias={ordenDias}
                            esTieneAmbas={esTieneAmbas}
                            formatearFechaLarga={formatearFechaLarga}
                            formatearFechaCorta={formatearFechaCorta}
                            copiarAlPortapapeles={(t) => copiarAlPortapapeles(t, showSuccessToast, showErrorToast)}
                            isAdmin={isAdmin}
                        />
                    )}
                </Card.Body>

                {/* Footer de Paginación */}
                <PaginacionFooter
                    totalRegistros={totalRegistros}
                    pagina={pagina}
                    tamanioPagina={tamanioPagina}
                    totalPaginas={totalPaginas}
                    busqueda={busqueda}
                    handleCambiarTamanio={(e) => { setTamanioPagina(Number(e.target.value)); setPagina(1); }}
                    handlePaginaAnterior={() => setPagina(prev => Math.max(1, prev - 1))}
                    handlePaginaSiguiente={() => setPagina(prev => Math.min(totalPaginas, prev + 1))}
                />
            </Card>

            {/* Modal de Confirmación */}
            <ModalConfirmacionBorrado
                modalConfirm={modalConfirm}
                cerrarModalConfirmacion={cerrarModalConfirmacion}
                cargando={cargando}
            />
        </>
    );
};

export default LicenciasVencidasDataBorrado;
